// @flow

import { Card, TitleWithUnderLine } from '@boi/core/lib';
import { noop } from '@boi/core/lib/utils';
import React from 'react';

import { commonPageStylesIdentifier } from '../../constants';
import {
  DISPLAY_NUM_OF_FEATURES_VIEW_RENEWAL,
  HOME_COVER_TYPE_VALUE,
  HOME_TYPE_VALUE
} from '../../constants/home';
import { insurerCaption } from '../../helpers';
import type {
  DefaultFinalQuote,
  FinalQuoteRenewal,
  RenewalQuoteResponseModel
} from '../../types/Home';
import QuoteRenewalOverview from '../QuoteRenewalOverview/QuoteRenewalOverview';

type Props = {
  classes: string,
  goToViewQuotePage: noop,
  quotesFinal: FinalQuoteRenewal,
  benefits: any
};

const QuoteRenewalOverviewContainer = ({
  classes,
  goToViewQuotePage,
  quotesFinal,
  benefits
}: Props) => {
  const cardTitle = (isAlternative: boolean) => (
    <div className={`${commonPageStylesIdentifier}__pageTitle`}>
      <TitleWithUnderLine>
        {isAlternative ? 'Your Alternative Quote' : 'Your Renewal'}
      </TitleWithUnderLine>
    </div>
  );

  const quoteType = (quote: RenewalQuoteResponseModel) =>
    HOME_TYPE_VALUE[
      HOME_COVER_TYPE_VALUE[
        quote.cover_details_information.risk_address.dwelling_type
      ]
    ];

  const renewalCard = (
    quote: RenewalQuoteResponseModel & DefaultFinalQuote,
    isAlternative: boolean,
    idx?: number
  ) => (
    <Card key={`renewalCard${quote.insurer}${idx || ''}`}>
      <QuoteRenewalOverview
        quoteTitle={cardTitle(isAlternative)}
        quoteType={quoteType(quote)}
        eircode={quote.cover_details_information.risk_address.post_code}
        policy_code={quote.policy_code}
        policy_id={quote.policy_id}
        scheme_code={quote.scheme_code}
        dates={{
          startDate: quote.cover_details_information.start_date,
          endDate: quote.cover_details_information.end_date
        }}
        direct_debit_policy={quote.direct_debit_policy}
        insurer={quote.insurer}
        alternativeQuote={isAlternative}
        underwritten={`${process.env.PUBLIC_URL ||
          ''}/asset/${quote.insurer.toLowerCase()}_logo.jpg`}
        underwrittenClass={`${(insurerCaption(quote.insurer).toLowerCase())}Logo`}
        quoteAmount={quote.price}
        quoteFeatures={benefits}
        showUpToFeature={DISPLAY_NUM_OF_FEATURES_VIEW_RENEWAL}
        goToViewQuotePage={goToViewQuotePage}
      />
    </Card>
  );

  const currentRenewal = quotesFinal?.currentRenewal;
  const alternativeRenewals = quotesFinal.alternativeQuote;

  return (
    <div className={`${classes}__renewalCards`} id={`${classes}__renewalCards`}>
      {!!currentRenewal && renewalCard(currentRenewal, false)}

      {alternativeRenewals?.length > 0 &&
        alternativeRenewals.map(
          (
            quote: RenewalQuoteResponseModel & DefaultFinalQuote,
            idx: number
          ) => (
            <>
              <br />
              {renewalCard(quote, true, idx)}
            </>
          )
        )}
    </div>
  );
};

export default QuoteRenewalOverviewContainer;
